import React from 'react'

import HeroBanner from './HeroBanner/HeroBanner'
import LogosCarousel from './LogosCarousel/LogosCarousel'
import SectionAppBioAtlas from './SectionAppBioAtlas/SectionAppBioAtlas'
import SectionCtaBioAtlas from './SectionCtaBioAtlas/SectionCtaBioAtlas'
import SectionCtaCytology from './SectionCtaCytology/SectionCtaCytology'
import SectionDepoimentos from './SectionDepoimentos/SectionDepoimentos'
import SectionEnriquecaAulas from './SectionEnriquecaAulas/SectionEnriquecaAulas'
import SectionEstudanteProfissional from './SectionEstudanteProfissional/SectionEstudanteProfissional'
import SectionModulosBioAtlas from './SectionModulosBioAtlas/SectionModulosBioAtlas'
import SectionResults from './SectionResults/SectionResults'
import SectionSolucaoBioAtlas from './SectionSolucaoBioAtlas/SectionSolucaoBioAtlas'
import SectionVantagensInstituicao from './SectionVantagensInstituicao/SectionVantagensInstituicao'
import AboutMedicalHarbour from '@/components/AboutMedicalHarbour/AboutMedicalHarbour'

const HomePageV2 = () => {
  return (
    <>
      <HeroBanner />
      <LogosCarousel />
      <SectionResults />
      <SectionEstudanteProfissional />
      <SectionVantagensInstituicao />
      <SectionEnriquecaAulas />
      <SectionCtaBioAtlas />
      <SectionSolucaoBioAtlas />
      <SectionModulosBioAtlas />
      <SectionCtaCytology />
      <SectionAppBioAtlas />
      <SectionDepoimentos />
      <AboutMedicalHarbour />
    </>
  )
}

export default HomePageV2
